export default __webpack_public_path__ + "static/media/General_Atomics.14749870.png";